
<div *ngIf="project$ | async as project; else loading">

  <div *ngIf="viewState === 'form'">
    <h2 class="widget-header" i18n="@@archive-project-header">Archive project in PDP</h2>
    <p>
      <span i18n="@@archive-project-help-text-1">You are about to archive</span>&nbsp;<strong>{{project.Name}}</strong>
    </p>

    <ul>
      <li>
        <span i18n="@@retention">Retention: </span>
        <span class="font-weight-bold" *ngIf="project.Retention === -1" i18n="@@retention-forever">Forever</span>
        <span class="font-weight-bold" *ngIf="project.Retention !== -1">{{project.Retention}} <span i18n="@@retention-years">years</span></span>
        <span class="ml-2"><a [routerLink]="'/edit-project-retention/' + project.PdpProjectId" i18n="@@change">(Change)</a></span>
      </li>
      <li>
        <span i18n="@@infoclass">InfoClass: </span>
        <span class="font-weight-bold" *ngIf="project.InfoClass === 1" i18n="@@infoclass-k1">K1 - Open</span>
        <span class="font-weight-bold" *ngIf="project.InfoClass === 2" i18n="@@infoclass-k2">K2 - Internal</span>
        <span class="font-weight-bold" *ngIf="project.InfoClass === 3" i18n="@@infoclass-k3">K3 - Sensitive</span>
        <span class="ml-2"><a [routerLink]="'/edit-project-infoclass/' + project.PdpProjectId" i18n="@@change">(Change)</a></span>
      </li>
      <li *ngIf="project.InfoClass <= 1" i18n="@@archive-project-help-k012">After Archiving: Edit permission for owners is removed. Whole organization can read. External project members are removed.</li>
      <li *ngIf="project.InfoClass >= 2" i18n="@@archive-project-help-k3">After Archiving: Edit permission for owners is removed. Internal project members can read. External project members are removed.</li>
      <li i18n="@@archive-project-help-contact">To supplement information after archiving, contact <a href="mailto:support.kvalitet@ri.se">support.kvalitet@ri.se</a></li>
    </ul>

    <p class="mt-5">
      <mat-checkbox color="primary" class="" #confirmed i18n="@@confirm-archive-project">Yes, I want to archive this project. <strong>This can not be undone.</strong></mat-checkbox>
    </p>

    <button mat-button mat-flat-button class="cancel-button mr-2" [routerLink]="'/'" type="button" i18n="@@cancel">Cancel</button>
    <button mat-button mat-flat-button color="primary" class="mt-4" [disabled]="!confirmed.checked" (click)="archiveProject()" type="button" i18n="@@archive-project">Archive project</button>
  </div>

  <div *ngIf="viewState === 'working'">
    <div class="text-center mt-6">
      <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
      <p i18n="@@please-wait">Please wait...</p>
    </div>
  </div>

  <div *ngIf="viewState === 'ready'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="ready-check ms-Icon ms-Icon--SkypeCircleCheck align-middle"></i>
        &nbsp;
        <strong>{{project.Name}}</strong>&nbsp;<span i18n="@@has-been-submitted-for-archiving">has been submitted for archiving!</span>
      </p>
      <p class="mt-5">
        <a i18n="@@back-to-project-list" [routerLink]="'/'">Return to the project list.</a>
      </p>
    </div>
  </div>

  <div *ngIf="viewState === 'error'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="error-icon ms-Icon ms-Icon--StatusErrorFull align-middle"></i>
        &nbsp;
        <span i18n="@@something-wend-wrong-archiving-the-project">Something went wrong. Please try again or contact support!</span>
      </p>
      <p>
        <small>{{errorMessage}}</small>
      </p>
    </div>
  </div>

</div>


<ng-template #loading>
  <div class="text-center mt-6">
    <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
  </div>
</ng-template>

